import useSWR from 'swr'

export function useStatsHome() {
  return useSWR(`https://api.skeleton.finance/fantom/stats/system`, (...args) =>
    fetch(...args).then((res) => res.json()),
  )
}
